import { render } from "./menu-application.vue?vue&type=template&id=446ceb9e&scoped=true"
import script from "./menu-application.vue?vue&type=script&lang=js"
export * from "./menu-application.vue?vue&type=script&lang=js"

import "./menu-application.vue?vue&type=style&index=0&id=446ceb9e&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446ceb9e"]])

export default __exports__